// extracted by mini-css-extract-plugin
module.exports = {"liquidFieldsContainer":"LineLengthDetails_liquidFieldsContainer__1T7Zk","alertMessageContainer":"LineLengthDetails_alertMessageContainer__1FuuZ"};